import type { Dayjs } from "dayjs";
import { authFetch } from "~/services/fetch";

interface getHistoricTraceDeviceProps {
  readonly deviceId: number;
  readonly startDate: Dayjs;
  readonly finishDate: Dayjs;
}

export async function getHistoricTraceDevice({ deviceId, startDate, finishDate }: getHistoricTraceDeviceProps) {
  try {
    const data = await authFetch({
      url: '/device/historical-trace',
      method: 'POST',
      data: {
        device_id: deviceId,
        start_date: startDate,
        finish_date: finishDate
      }
    })

    return data
  } catch (error) {
    throw error;
  }
}